module.exports = __webpack_public_path__ + "static/media/eve-dop.4325ec71.svg";